import React, { memo, useState } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  useTheme,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import HeaderAcordeon from './HeaderAcordeon/HeaderAcordeon';
import HeaderAcordeonPersonalized from './HeaderAcordeonPersonalized';
import FlightItineraryDetail from '@shared/pages/Flights/components/FlightItineraryDetail';

const Acordeon = ({
  object_option,
  title,
  index,
  indexLeg,
  activeRadio,
  handleRadio,
  next_leg_options,
  next_cluster,
  isCustomSearch,
  isForcedSelected,
  idPrefix,
}) => {
  const theme = useTheme();

  const [expanded, setExpanded] = useState(false);

  const handleChangeExpanded = panel => (_event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const Header = isCustomSearch ? HeaderAcordeonPersonalized : HeaderAcordeon;

  const headerId = idPrefix
    ? `${idPrefix}-header`
    : `accordion-header-${object_option?.hash}`;

  const contentId = idPrefix
    ? `${idPrefix}-content`
    : `accordion-content-${object_option?.hash}`;

  return (
    <Grid id={idPrefix ?? object_option.cluster_id}>
      <Grid item>
        <Accordion
          expanded={expanded === object_option.hash}
          onChange={handleChangeExpanded(object_option.hash)}
          sx={{
            border: isForcedSelected
              ? '2px solid #d6d6d6'
              : '1px solid transparent',
            boxShadow:
              '0px 2px 1px -1px #636466, 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)',
            '&:last-of-type': {
              borderBottomLeftRadius: { xs: 0, lg: '8px' },
              borderBottomRightRadius: { xs: 0, lg: '8px' },
              '&:hover': {
                bgcolor: expanded === object_option.hash ? 'none' : '#f0f0f0',
              },
            },
          }}
        >
          <AccordionSummary
            expandIcon={
              <ExpandMoreIcon
                sx={{ color: theme.tertiary, alignSelf: 'center' }}
              />
            }
            aria-controls={contentId}
            id={headerId}
            sx={{
              minHeight: isCustomSearch ? 50 : 60,
              maxHeight: isCustomSearch ? 65 : 80,
              display: 'flex',
              alignItems: 'center',
              p: { xs: '0px 8px', sm: '0px' },
              '& .MuiAccordionSummary-expandIconWrapper': {
                mr: 1,
              },
            }}
          >
            <Header
              object_option={object_option}
              next_leg_options={next_leg_options}
              next_cluster={next_cluster}
              indexLeg={indexLeg}
              title={title}
              index={index}
              handleRadio={handleRadio}
              activeRadio={activeRadio}
            />
          </AccordionSummary>

          <AccordionDetails>
            <Grid
              container
              item
              sx={{
                display: 'flex',
                justifyContent: 'center',
                px: { xs: 1, sm: 0 },
              }}
            >
              {expanded === object_option.hash && (
                <FlightItineraryDetail
                  flights={object_option.flights}
                  id_option={object_option.id_option}
                  idPrefix={idPrefix}
                />
              )}
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </Grid>
  );
};

export default memo(Acordeon);
